export enum FermentationQueryKeys {
  GetAllFermentations = 'GET_ALL_FERMENTATION',
  GetAFermentations = 'GET_A_FERMENTATION',
  GetBatchesOfFermentation = 'GET_ALL_BATCHES_IN_FERMENTATION',
  GetFavouriteFermentations = 'GET_FAVOURITE_FERMENTATIONS',
}
